// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { gameController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_mighty_scope_popup_image, s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green, s_icon_movie, s_popup_close, s_icon_close } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { playController } from "../gameController";
import { LoadingOverlay } from "./LoadingOverlay";
import { YoutubeStorageManager } from "../storage/YoutubeStorageManager";
tgfSettings.dialogDefaults.MightyScopeDialog = {
    width: 800,
    height: 550,
    text: "MIGHTYSCOPE_BODY_TEXT",
    yesText: "BTN_MIGHTYSCOPE",
    headerText: "MIGHTYSCOPE_HEADER",
    image: s_mighty_scope_popup_image,
    font: DialogSettings.textFont,
    yesButtonFont: DialogSettings.buttonFont,
    components: [] // The additional components to add
};
export var MightyScopeDialog = function (properties) {
    "use strict";
    this.name = "MightyScopeDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.MightyScopeDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
    AngryAnalytics.reportScopeOpen();
};
// Inherit the base dialog
tgfDialogs.inherit(MightyScopeDialog, DialogBase);
MightyScopeDialog.prototype.doPrepare = function () {
    "use strict";
    if (playController) {
        playController.toggleSlingshotInput(false);
    }
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({ image: s_popup_top, x: tgfGraphics.areaWidth / 2, y: -285 + tgfGraphics.areaHeight / 2 });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({ image: s_popup_bottom, x: tgfGraphics.areaWidth / 2, y: 255 + tgfGraphics.areaHeight / 2 }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText(this.headerText),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.centerImage = new ComponentPicture({
        image: this.image,
        y: -120,
        xScale: 1.5,
        yScale: 1.5,
    });
    this.transparentBlack.addComponent(this.centerImage);
    this.label = new ComponentLabel({
        text: String.format(tgfDictionary.getText(this.text), PowerUpSettings.mightyScopeDuration),
        x: 0,
        y: 25,
        width: this.background.width * 0.9,
        splitLines: true,
        font: this.font
    });
    this.transparentBlack.addComponent(this.label);
    this.yesButton = new ComponentButton({
        image: s_btn_green,
        icon: s_icon_movie,
        iconPosition: "right",
        iconXScale: 0.5,
        iconYScale: 0.5,
        text: tgfDictionary.getText(this.yesText),
        x: 0,
        y: 150,
        onClick: this.onAccept.bind(this),
        fontUp: this.yesButtonFont
    });
    this.transparentBlack.addComponent(this.yesButton);
    this.noButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        x: this.width / 2 + 5,
        y: 33,
        onClick: this.onDecline.bind(this),
    });
    this.headerBackground.addComponent(this.noButton);
    if (playController) {
        playController.activeMightyScopeDialog = this;
    }
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
};
MightyScopeDialog.prototype.onDecline = function () {
    AngryAnalytics.reportScopeClose();
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    gameController.mightyScopeDialogEnabled = false;
    this.close(true);
};
MightyScopeDialog.prototype.onAccept = function () {
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    gameController.mightyScopeDialogEnabled = true;
    AngryAnalytics.reportScopeAdButtonPressed();
    this.onAdSuccess.call(this);
};
MightyScopeDialog.prototype.onAdSuccess = function () {
    playController.sceneBuilder.cameraToSlingshot(true, function () {
        playController.sceneController.enableMightyScope();
    });
    gameController.mightyScopeEnd = Date.now() + PowerUpSettings.mightyScopeDuration * 60 * 1000;
    YoutubeStorageManager.savePlayerData([PowerUpSettings.mightyScopeServerTag], [gameController.mightyScopeEnd], function () { }, function (err) {
        console.error(err);
    });
    this.close(true);
};
MightyScopeDialog.prototype.close = function (callOnClose) {
    if (playController) {
        playController.toggleSlingshotInput(true);
    }
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (playController) {
        playController.activeMightyScopeDialog = null;
    }
    if (this.onClose && callOnClose) {
        this.onClose();
    }
};
MightyScopeDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
